import React from 'react';

import SvgContainer from '../SvgContainer';

const Warning = () => {
    return (
        <SvgContainer>
            <g clipPath="url(#clip0_9085_100941)">
                <path d="M7 11.7C7 12.2523 7.44772 12.7 8 12.7C8.55229 12.7 9 12.2523 9 11.7V11.6C9 11.0477 8.55229 10.6 8 10.6C7.44772 10.6 7 11.0477 7 11.6V11.7ZM7 8.4C7 8.95228 7.44772 9.4 8 9.4C8.55229 9.4 9 8.95229 9 8.4V4.5C9 3.94772 8.55229 3.5 8 3.5C7.44772 3.5 7 3.94771 7 4.5V8.4ZM8 16C3.584 16 0 12.416 0 8C0 3.584 3.584 0 8 0C12.416 0 16 3.584 16 8C16 12.416 12.416 16 8 16ZM8 1.6C4.472 1.6 1.6 4.472 1.6 8C1.6 11.528 4.472 14.4 8 14.4C11.528 14.4 14.4 11.528 14.4 8C14.4 4.472 11.528 1.6 8 1.6Z" />
            </g>
            <defs>
                <clipPath id="clip0_9085_100941">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </SvgContainer>
    );
};

export default Warning;
